module.exports = __webpack_public_path__ + "media/images/course/aula_06__-80aac7190a6fb4319d9fdb418a4a4e9c.png";